import { EVENT, dispatchCustomEvent } from '@/helpers/customEvents'

export const getCurrentUrl = () => window.location.href

export const generateTimestamp = () => Math.floor(Date.now() / 1000)

export const formatDate = dateTime => new Date(dateTime)
  .toLocaleDateString(
    'de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }
  )

export const isSameDay = (dateA, dateB) =>
  dateA.getFullYear() === dateB.getFullYear() &&
  dateA.getMonth() === dateB.getMonth() &&
  dateA.getDate() === dateB.getDate()

export const isDeactivated = (config) => {
  switch (config.channel) {
    case 'WEBSITE':
      return process.env.VUE_APP_DEACTIVATE_WEBSITE
    case 'KUPOWEB':
      return process.env.VUE_APP_DEACTIVATE_KUPOWEB
    case 'KUPOAPP':
      return process.env.VUE_APP_DEACTIVATE_KUPOAPP
    case 'KUPOAPP_HN':
      return process.env.VUE_APP_DEACTIVATE_KUPOAPP_HN
  }

  return false
}

export const dispatchLatestUnreadMessage = (unreadMessages, isChatOpen) => {
  if (!unreadMessages.length || isChatOpen) {
    return
  }
  
  const { msgId, msgDate, msgText } = unreadMessages[unreadMessages.length - 1]
  const payload = {
    detail: {
      count: unreadMessages.length,
      latestMessage: {
        identifier: msgId,
        isoUtcDate: (new Date(msgDate)).toISOString(),
        content: msgText
      }
    }
  }
  
  dispatchCustomEvent(EVENT.SEND.NEW_UNREAD_MESSAGE, payload)
}